export enum AssetEnum {
  ETH = 'ETH',
  USDC = 'USDC',
  USDT = 'USDT',
  OP = 'OP',
  MATIC = 'MATIC',
}
